// Date range presets as 'YYYY-MM-DD' calendar days in the company's time zone
// (companies.timezone, returned on /api/auth/me as user.timezone). These were
// built from the browser's local day and toISOString(), the UTC day, so after
// 7 PM CDT "today" was already tomorrow and on the last evening of a month
// "this month" was next month.

import { DEFAULT_TIMEZONE } from './companyDate';

const DAY_MS = 24 * 60 * 60 * 1000;
const iso = (ms) => new Date(ms).toISOString().slice(0, 10);

// Today in the zone, as a UTC-midnight timestamp of that calendar day, so the
// arithmetic below is plain calendar arithmetic with no zone in it. en-CA
// formats as YYYY-MM-DD.
const companyTodayUtc = (timezone, now) => {
  const [y, m, d] = now
    .toLocaleDateString('en-CA', { timeZone: timezone || DEFAULT_TIMEZONE })
    .split('-')
    .map(Number);
  return Date.UTC(y, m - 1, d);
};

// this_week: Sunday of this week to today. month_to_date: the 1st to today.
// this_month: the 1st to the last day. last_month: all of last month.
export const companyDateRange = (preset, timezone, now = new Date()) => {
  const today = companyTodayUtc(timezone, now);
  const t = new Date(today);
  const y = t.getUTCFullYear();
  const m = t.getUTCMonth();
  switch (preset) {
    case 'this_week':
      return { start: iso(today - t.getUTCDay() * DAY_MS), end: iso(today) };
    case 'month_to_date':
      return { start: iso(Date.UTC(y, m, 1)), end: iso(today) };
    case 'this_month':
      return { start: iso(Date.UTC(y, m, 1)), end: iso(Date.UTC(y, m + 1, 0)) };
    case 'last_month':
      return { start: iso(Date.UTC(y, m - 1, 1)), end: iso(Date.UTC(y, m, 0)) };
    default:
      return { start: '', end: '' };
  }
};
